// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Card-module--cls1--PQ1RI","cls2":"styles-Card-module--cls2--32smY styles-Card-module--cls1--PQ1RI"};